(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["MM-Grid-Actifs"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener("DOMContentLoaded", () => {
		// Initialize Splide slider
		initializeSectionsWithSplide('data-slider-tabs', '.mm-slider-tabs', (splideElem) => {
			const splideInstance = new Splide(splideElem, {
				type: 'slide',
				arrows: false,
				pagination: false,
				perPage: 1,
				snap: true,
				fixedWidth: 'fit-content',
				gap: '8px',
				focus: 'center'
			}).mount();

			addHorizontalScrollListener(splideElem, splideInstance);
		});

		// Filter functionality
		const filterTags = document.querySelectorAll('.mm-grid-actifs-tag');
		const gridContainer = document.querySelector('.mm-grid-actifs-container');
		const countElement = document.querySelector('.mm-grid-actifs-count');

		// Store all cards with their original data
		const allCards = Array.from(document.querySelectorAll('.mm-actif-card')).map(card => ({
			element: card,
			tags: card.getAttribute('data-actif-tags') || ''
		}));

		function updateCount(visibleCount) {
			if (countElement) {
				// Get translation template and replace count
				const countText = countElement.textContent;
				const updatedText = countText.replace(/\d+/, visibleCount);
				countElement.textContent = updatedText;
			}
		}

		function filterActifs(selectedTag) {
			// Clear grid container
			gridContainer.innerHTML = '';

			let visibleCount = 0;

			allCards.forEach(cardData => {
				if (selectedTag === 'all') {
					// Show all cards
					gridContainer.appendChild(cardData.element);
					visibleCount++;
				} else {
					// Check if card has the selected tag
					if (cardData.tags.includes(selectedTag + ',')) {
						gridContainer.appendChild(cardData.element);
						visibleCount++;
					}
				}
			});

			updateCount(visibleCount);
		}

		// Add click event to all filter tags
		filterTags.forEach(tag => {
			tag.addEventListener('click', (e) => {
				// Remove active class from all tags
				filterTags.forEach(t => t.classList.remove('active'));

				// Add active class to clicked tag
				tag.classList.add('active');

				// Get selected tag
				const selectedTag = tag.getAttribute('data-filter-tag');

				// Filter actifs
				filterActifs(selectedTag);
			});
		});
	});

  } catch(e) { console.error(e); }
})();
})();
